import { Loader2 } from 'lucide-react';
import React from 'react';
import { FeedbackMessage } from '../components/feedback-message';
import { MessageBubble } from '../components/message-bubble';

interface TranscriptMessage {
  messageIndex: number;
  speaker: 'user' | 'assistant';
  message: string;
  feedbackType: 'suggestion' | 'warning' | 'praise' | 'none';
  feedback?: string;
}

interface TranscriptBreakdownTabProps {
  transcriptAnalysis?: TranscriptMessage[];
  isLoading?: boolean;
  selectedParticipant?: string;
  otherParticipants?: [string];
}

export const TranscriptBreakdownTab: React.FC<TranscriptBreakdownTabProps> = ({
  transcriptAnalysis,
  isLoading = false,
  selectedParticipant,
  otherParticipants,
}) => {
  if (isLoading) {
    return (
      <div className="p-6 flex flex-col justify-center items-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" />
        <span className="mt-4 text-gray-600">
          Loading transcript analysis...
        </span>
      </div>
    );
  }

  if (!transcriptAnalysis || transcriptAnalysis.length === 0) {
    return (
      <div className="p-6">
        <h2 className="text-xl font-medium mb-4">Transcript breakdown</h2>

        <div className="bg-gray-50 p-8 rounded-lg text-center">
          <p className="text-gray-500">
            Transcript analysis not available for this meeting.
          </p>
          <p className="text-gray-500 text-sm mt-2">
            This feature will provide detailed feedback on specific exchanges in
            future meetings.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="divide-y divide-[#e0e0e0]">
        {transcriptAnalysis.map((item, index) => (
          <div key={index} className="py-3 first:pt-4 last:pb-4">
            <MessageBubble
              speaker={
                item.speaker === selectedParticipant ? 'You' : item.speaker
              }
              message={item.message}
            />
            {item.feedbackType !== 'none' && item.feedback && (
              <div className="mt-4">
                <FeedbackMessage
                  type={
                    item.feedbackType as
                      | 'suggestion'
                      | 'warning'
                      | 'praise'
                      | 'none'
                  }
                  message={item.feedback}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
